<template>
<!-- eslint-disable max-len -->
  <!---We're not actually using the list page here because we want to display a directory tree-->
<div class="container">
<div class="row no-gutters">
<div class="list-form col-sm-12">
  <h2>Character Explorer</h2>
  <character-tree-visualizer allow-editing />
</div>
</div>
</div>
</template>

<script>
import { mapActions } from 'vuex';
import CharacterTreeVisualizer from './components/CharacterTreeVisualizer';

export default {
  components: {
    CharacterTreeVisualizer
  },
  methods: {
    ...mapActions([
    ]),
  }
};
</script>

<style lang="scss" scoped>
.list-form {
  margin-top: 50px;
  padding: 20px;
  background-color: white;
}
.list-form ul {
  list-style: none;
  padding-left: 0;
}
.list-form li {
  color: black;
  border: 2px solid black;
  padding: 5px;
  margin-bottom: 5px;
}
.list-form li:hover {
  border: 2px solid;
  border-color: var(--primaryColor);
  background-color: var(--primaryColor);
  color: white;
}
.list-form li p {
  margin: 0;
}
.list-form li p:first-of-type {
  font-weight: bold;
}
.icon {
  max-height: 75px;
}
.create-btn {
  margin: 0;
  line-height: 2em;
  padding: 2px 10px 3px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/CharacterTreeList.vue